'use client'

import { useEffect, useState } from 'react'
import { useTranslation } from '../../../context/ConfigContext'
import { Button } from '../../Button/Button'
import FilterProductFormMobileMenu from './FilterProductFormMobileMenu'
import Icon from '../../Icon/Icon'
import { Icons } from '../../Icon/constants'

const FilterProductFormMobile = ({
  filterProducts,
  orderProducts,
  nbArticles,
  clearFilters,
  hasFilterSelected,
  changeSortBy,
}) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false)
  const t = useTranslation()

  useEffect(() => {
    setTimeout(() => setIsOrderModalOpen(false), 800)
  }, [changeSortBy])

  const openFilterModal = () => {
    setIsFilterModalOpen(true)
    document.body.classList.add('no-overflow')
  }
  const closeFilterModal = () => {
    setIsFilterModalOpen(false)
    document.body.classList.remove('no-overflow')
  }

  const openOrderModal = () => {
    setIsOrderModalOpen(true)
    document.body.classList.add('no-overflow')
  }
  const closeOrderModal = () => {
    setIsOrderModalOpen(false)
    document.body.classList.remove('no-overflow')
  }

  return (
    <div className='filter-product-form-mobile'>
      <FilterProductFormMobileMenu
        openFilterModal={() => openFilterModal()}
        openOrderModal={() => openOrderModal()}
      />
      {isFilterModalOpen && (
        <div className='filter-product-form-modal'>
          <div className='filter-product-form-modal-header'>
            <p className='filter-product-form-modal-header-title'>{t('Filter by')}</p>
            <div className='filter-product-form-modal-header-actions'>
              {nbArticles < 2 ? (
                <span className='filter-product-form-modal-header-nbarticles'>
                  {nbArticles} {t('Item')}{' '}
                </span>
              ) : (
                <span className='filter-product-form-modal-header-nbarticles'>
                  {nbArticles} {t('Items')}{' '}
                </span>
              )}
              <button
                onClick={() => closeFilterModal()}
                type='button'
                className='filter-product-form-modal-header-close'>
                <Icon iconName={Icons.CLOSE} />
              </button>
            </div>
          </div>
          <div className='filter-product-form-modal-content'>
            {filterProducts}
            <div className='filterproducts-buttons'>
              <div className='filterproducts-buttons-delete'>
                <Button
                  classname='button border-black'
                  onClick={hasFilterSelected && clearFilters}
                  label={t('Clear All', {}, false)}
                  primary
                  disabled={!hasFilterSelected}
                />
              </div>
              <div className='filterproducts-buttons-validate'>
                <Button
                  classname='button black'
                  onClick={() => closeFilterModal()}
                  label={t('apply', {}, false)}
                  primary
                  style='dark'
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOrderModalOpen && (
        <div className='filter-product-form-modal'>
          <div className='filter-product-form-modal-header'>
            <p className='filter-product-form-modal-header-title'>{t('SORT BY')}</p>
            <div className='filter-product-form-modal-header-actions'>
              {nbArticles && (
                <span className='filter-product-form-modal-header-nbarticles'>
                  {nbArticles} {t('Items')}
                </span>
              )}
              <button
                onClick={() => closeOrderModal()}
                type='button'
                className='filter-product-form-modal-header-close'>
                <Icon iconName={Icons.CLOSE} />
              </button>
            </div>
          </div>
          <div className='filter-product-form-modal-content'>{orderProducts}</div>
        </div>
      )}
    </div>
  )
}

export default FilterProductFormMobile
